import React from "react";

const DAYS = [
  ["monday", "Mon"],
  ["tuesday", "Tue"],
  ["wednesday", "Wed"],
  ["thursday", "Thu"],
  ["friday", "Fri"],
  ["saturday", "Sat"],
  ["sunday", "Sun"],
];

export function normalizeWeekly(v) {
  if (!v || v === "none") return [];
  if (v === "saturday_sunday") return ["saturday", "sunday"];
  return v.split(",").map((s) => s.trim().toLowerCase()).filter(Boolean);
}

export function weeklyLabel(v) {
  const days = normalizeWeekly(v);
  if (days.length === 0) return "No weekly off";
  const map = Object.fromEntries(DAYS);
  return days.map((d) => map[d] || d).join(", ");
}

export default function WeeklyDaysPicker({ value, onChange }) {
  const sel = new Set(normalizeWeekly(value));
  const toggle = (d) => {
    const n = new Set(sel);
    n.has(d) ? n.delete(d) : n.add(d);
    // preserve canonical order Mon->Sun
    const ordered = DAYS.map(([k]) => k).filter((k) => n.has(k));
    onChange(ordered.join(","));
  };
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="weekly-days-picker">
      {DAYS.map(([key, label]) => {
        const active = sel.has(key);
        return (
          <button
            type="button"
            key={key}
            data-testid={`weekly-day-${key}`}
            onClick={() => toggle(key)}
            className={`px-3 py-2 rounded-lg text-sm font-medium border transition-colors ${
              active ? "bg-blue-600 text-white border-blue-600" : "bg-slate-50 text-slate-600 border-slate-200 hover:border-blue-300"
            }`}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
